// src/utils/constants.js
export const API_URL = process.env.REACT_APP_API_ENDPOINT;
export const DOCS_URL = 'https://docs.dataapi.store';